
import req, {reqAuth} from './req';
import routes from 'configs/routes';
import clg from './log';
import settings from 'configs/settings';

class Auth {
  constructor() {
    this.authObj = {
      authenticated: (JSON.parse(localStorage.getItem("authData")) ? JSON.parse(localStorage.getItem("authData")).authenticated : false),
      accessToken: (JSON.parse(localStorage.getItem("authData")) ? JSON.parse(localStorage.getItem("authData")).accessToken : ""),
      refreshToken: (JSON.parse(localStorage.getItem("authData")) ? JSON.parse(localStorage.getItem("authData")).refreshToken : ""),
      refreshRequestSent: false,
      alertHasShown: false,
    }
    this.history = {};
  }

  login = (loginDataObj) => {
    return new Promise((resolve, reject) => {
      req({ url : settings.req.login, method : "POST",  data : loginDataObj})
        .then((obj) => {
          if (obj.success) {
            this.authObj.authenticated = true;
            this.authObj.accessToken = obj.data.access_token;
            this.authObj.refreshToken = obj.data.refresh_token;
            localStorage.setItem('authData', JSON.stringify(this.authObj));
          }
          resolve(obj)
        }).catch(error => reject(error));
    })
  }

  logout(reason = "") { //reason lehet: EXPIRED_TOKEN
    this.history.push( routes.login );
    this.authObj.authenticated = false;
    this.authObj.accessToken = "";
    this.authObj.refreshToken = "";
    this.authObj.refreshRequestSent = false;
    localStorage.removeItem('authData');

    /* reqAuth( settings.req.logout, {} ).then(function(res){
      clg("LOGOUT RESP: ", res);
    }) */
  }

  getAccessToken() {
    return this.authObj.accessToken;
  }

  getRefreshToken() {
    return this.authObj.refreshToken;
  }

  renewTokens(accessToken, refreshToken) {
    this.authObj.accessToken = accessToken;
    this.authObj.refreshToken = refreshToken;
    localStorage.setItem('authData', JSON.stringify(this.authObj));
  }

  isAuthenticated() {
    return this.authObj.authenticated;
  }

  getRefreshRequestSent() {
    return this.authObj.refreshRequestSent;
  }

  setRefreshRequestSent(boolean) {
    this.authObj.refreshRequestSent = boolean;
  }

  getAuthObj(){
    return this.authObj;
  }

  setHistory(setTo) {
    this.history = setTo;
  }

}

export default new Auth();